export var TableHeaderStylePropertiesByVariant = {
    textLeftAlign: function () { return ({
        textAlign: 'left',
    }); },
    textRightAlign: function () { return ({
        textAlign: 'right',
    }); },
};
//# sourceMappingURL=TableHeaderStylePropertiesByVariant.js.map